// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2[data-v-63388ccc],h3[data-v-63388ccc],h4[data-v-63388ccc]{color:#46426b}.faded-background[data-v-63388ccc]{background:linear-gradient(180deg,rgba(148,149,207,.18),rgba(118,120,237,0))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
